<template>
    <section>
        <o-field label="Select a month">
            <o-datepicker
                placeholder="Click to select..."
                icon="calendar"
                type="month" />
        </o-field>
    </section>
</template>
